/**
 * True iff the event renders **persistent** UI in the patient chat view.
 *
 * This is the single source of truth for per-viewer event visibility: it drives the
 * patient render switch and the "new messages" divider anchoring (only events that
 * stay on screen are valid divider anchors). `AGENT_BUSY` is deliberately excluded —
 * it is a transient typing indicator rendered only while it is the last event, so it
 * must never anchor the divider.
 *
 * `AGENT_MESSAGE`/`AGENT_QUESTION` count only when targeted at the patient; the staff
 * predicate intentionally differs here (staff sees both targets).
 *
 * @__NO_SIDE_EFFECTS__
 */
export function isPatientVisibleEvent(event) {
    switch (event.type) {
        case 'AGENT_MESSAGE':
        case 'AGENT_QUESTION':
            return event.target === 'PATIENT';
        case 'CHAT_END':
        case 'PATIENT_ANSWER':
        case 'PATIENT_MESSAGE':
        case 'PROFILE_DATA_REQUEST':
        case 'PROFILE_DATA_SENT':
        case 'STAFF_JOIN':
        case 'STAFF_MESSAGE':
        case 'SUBSCRIPTION_REQUEST':
        case 'SUBSCRIPTION_START':
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=isPatientVisibleEvent.js.map